import { SET_APP_CURRENT_PATH } from '../../constants/actionTypes';

const initialState = {
  currentPath: null,
  previousPath: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_APP_CURRENT_PATH: {
      const {
        payload: { currentPath },
      } = action;

      return {
        ...state,
        previousPath: state.currentPath,
        currentPath,
      };
    }

    // case LOGOUT_COMPLETE:
    //   return initialState;

    default:
      return state;
  }
}
